import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { AppConfig } from 'src/assets/config/config/app-config';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

    public currentUserSubject: BehaviorSubject<any>;

    public currentUser: Observable<string>;

    public userGroupsSubject: BehaviorSubject<any>;

    public userGroups: Observable<string[]>;

    public isAdminSubject: BehaviorSubject<any>

    public isAdmin: Observable<boolean>

    constructor(
        private http: HttpClient,
        private config: AppConfig
    ) {
        this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
        this.userGroupsSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('userGroups')));
        this.userGroups = this.userGroupsSubject.asObservable();
        this.isAdminSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('isAdmin')))
    }

    public get currentUserValue() {
        return this.currentUserSubject.value;
    }

    public get userGroupsValue() {
        return this.userGroupsSubject.value;
    }

    public get isAdminValue() {
        return this.isAdminSubject.value;
    }

    logout() {
        // remove user from local storage and set current user to null
        localStorage.removeItem('currentUser');
        localStorage.removeItem('userGroups');
        localStorage.removeItem('isAdmin');
        this.currentUserSubject.next(null);
        this.userGroupsSubject.next(null);
        this.isAdminSubject.next(null)
    }


    getToken(body) {

        var apiUrl = this.config.getConfig("serviceurl");
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })           
          };
        return this.http.post<any>(apiUrl + `/login/getAccessToken`, body, httpOptions)

            .pipe()
    }

    validateSession(baseUrl, token) {		
        let oAuthToken = "Bearer " + token;			
        const httpOptions = {
            headers: new HttpHeaders({
                'Accept': 'application/json',
                'Authorization': oAuthToken
            })           
            };
        return this.http.get<any>(baseUrl, httpOptions).toPromise();
    }
}